import { useEffect, useState } from "react";
import type { MfaEmailCodeSent } from "../types";

/**
 * Seconds left before another code may be sent, 0 once it may. Counted from
 * `receivedAt` with the server's duration, so a client clock that drifts from
 * the server's does not matter.
 */
export function useResendCountdown(
	codeSent: MfaEmailCodeSent | null | undefined,
): number {
	const [now, setNow] = useState(() => Date.now());

	useEffect(() => {
		if (!codeSent) {
			return;
		}
		const deadline =
			codeSent.receivedAt + codeSent.resendAvailableInSeconds * 1000;
		const interval = setInterval(() => {
			const current = Date.now();
			setNow(current);
			if (current >= deadline) {
				clearInterval(interval);
			}
		}, 1000);
		return () => clearInterval(interval);
	}, [codeSent]);

	if (!codeSent) {
		return 0;
	}
	// `now` may predate the answer on the first render: never count from before.
	const elapsedMs = Math.max(0, now - codeSent.receivedAt);
	return Math.max(
		0,
		Math.ceil(codeSent.resendAvailableInSeconds - elapsedMs / 1000),
	);
}
